export const fadeSlideTransition: any = {
  enterActiveClass: "transition-all duration-250",
  enterFromClass: "opacity-0 -translate-y-6",
  enterToClass: "opacity-100",
  leaveActiveClass: "transition-all duration-250",
  leaveFromClass: "opacity-100 ",
  leaveToClass: "opacity-0 -translate-y-6",
  mode: "out-in",
};

export const fadeInTransition: any = {
  enterActiveClass: "transition-all duration-500",
  enterFromClass: "opacity-0",
  enterToClass: "opacity-100",
};

export const fadeTransition: any = {
  enterActiveClass: "transition-all duration-200",
  enterFromClass: "opacity-0",
  enterToClass: "opacity-100",
  leaveActiveClass: "transition-all duration-200",
  leaveFromClass: "opacity-100",
  leaveToClass: "opacity-0",
};

export const fadeTransitionSlow: any = {
  enterActiveClass: "transition-all duration-500",
  enterFromClass: "opacity-0",
  enterToClass: "opacity-100",
  leaveActiveClass: "transition-all duration-500",
  leaveFromClass: "opacity-100",
  leaveToClass: "opacity-0",
};

export const wipeTransition: any = {
  enterActiveClass: "transition-transform duration-500 ease-out z-10",
  enterFromClass: "-translate-x-full",
  enterToClass: "translate-x-0 ",
  leaveActiveClass: "absolute duration-[0.49s]",
  leaveFromClass: "translate-x-0 opacity-1",
  mode: "default",
};

export const pushUpTransition: any = {
  enterActiveClass: "transition-[transform,opacity] duration-500 ease-out",
  enterFromClass: "translate-y-full opacity-0",
  enterToClass: "translate-y-0 opacity-1",
  leaveActiveClass: "transition-opacity duration-500",
  leaveFromClass: "opacity-100",
  leaveToClass: "opacity-0",
};

export const pushDownTransition: any = {
  enterActiveClass: "transition-[transform,opacity] duration-500 ease-out",
  enterFromClass: "-translate-y-full opacity-0",
  enterToClass: "translate-y-0 opacity-1",
  leaveActiveClass: "transition-opacity duration-500",
  leaveFromClass: "opacity-100",
  leaveToClass: "opacity-0",
};
